import { css } from "styled-components";

const NoTextSelectionStyles = css`
     user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
`;

export default NoTextSelectionStyles;